<template>
	<div class=" project">
		<div class="clear-both mb-2 mr-4" v-show="type == 2">
			<el-button type="primary" class="fr ml-1" @click="postCusInfo"
				:loading="loadingAddBtn">{{ loadingAddBtn ? '保存中...' : '保存' }}</el-button>
			<el-button class="fr mr-1" @click="isDisabled = false" :disabled="isEdit" v-show="isDisabled">编辑</el-button>
			<el-button class="fr mr-1" @click="isDisabled = true" v-show="!isDisabled">取消</el-button>
		</div>
		<el-form :model="project" ref="projectForm" :rules="rules" label-position="left" label-width="120px"
			class="employer-ruleForm">
			<!-- <el-row v-show="type!=2">
				<el-col :span="24">
					<el-form-item label="" label-width="120px">
						<div>
							<el-radio v-model="project.company" label="1">有项目公司</el-radio>
							<el-radio v-model="project.company" label="2">暂无项目公司</el-radio>
						</div>
					</el-form-item>
				</el-col>
			</el-row> -->
			<el-row v-show="type != 2">
				<el-col :span="24">
					<el-form-item label="企业名称" required label-width="120px">
						<seach v-show="project.company == '1'" @select="handleSelect" id="customerNameId1"
							ref="customerSearch"></seach>
						<el-input v-show="project.company == '2'" v-model="project.customerName"
							placeholder="请输入项目发起方名称" class="inp_text" id="customerNameId2"
							ref="customerInput"></el-input>

					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="项目名称" prop="name" label-width="120px">
						<el-input v-model="project.name" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<el-form-item label="项目状态" prop="status" label-width="120px">
						<el-select v-model="project.status" placeholder="请选择" style="width: 100%;"
							:disabled="isDisabled">
							<el-option v-for="item in projectStatusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<!-- <el-input v-model="project.status" :disabled="isDisabled"></el-input> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="投资方名称" prop="investorName" label-width="120px">
						<el-input v-model="project.investorName" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<!-- <el-form-item label="拟落地区域" label-width="120px">
												<el-input v-model="project.district" :disabled="isDisabled"></el-input>
											</el-form-item> -->
					<el-form-item label="产业类型" prop="industryType" label-width="120px">
						<!-- <el-input v-model="project.industryType" :disabled="isDisabled"></el-input> -->
						<el-cascader style="width: 100%;" v-model="project.industryType" :options="industryTypeOptions"
							:disabled="isDisabled">
						</el-cascader>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="投资总额" prop="investmentAmount" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.investmentAmount"
								:disabled="isDisabled"></el-input></div> 亿元
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<el-form-item label="预计年产值" prop="expectedAnnualOutput" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.expectedAnnualOutput"
								:disabled="isDisabled"></el-input></div>亿元
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="预计利润" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.expectedProfit"
								:disabled="isDisabled"></el-input></div>亿元
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<el-form-item label="预计就业人数" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.expectedEmployment"
								:disabled="isDisabled"></el-input></div>人
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="税收" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.taxation" :disabled="isDisabled"></el-input>
						</div>亿元
					</el-form-item>
				</el-col>

			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目附件" prop="fileList" label-width="120px">
						<el-upload :disabled="isDisabled" class="upload-demo" action="#" :http-request="uploadFileList"
							:on-preview="handlePreview" :on-remove="handleRemove" multiple :limit="4"
							:before-remove="beforeRemove" :on-success="handleAvatarSuccess" :on-exceed="handleExceed"
							:file-list="project.projectFileList" :show-file-list="project.showFileList"
							accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
							<el-button size="small" type="primary" :disabled="isDisabled">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">仅支持上传 Word、PDF、Excel、PPT格式，且单个文件大小不超过
								30MB</div>
						</el-upload>
						<!-- <span v-for="(file, index) in projectFileList" :key="index"
							v-show="projectFileList.length>0" class="curp display-block"
							@click="handleOpenURL(file.url)">{{file.name}} ></span> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="type != 1">
				<el-col :span="24">
					<el-form-item label="项目信息完整性评估" prop="" label-width="160px">
						<el-button type="primary" :loading="completenesLoading"
							@click="initEvaluation(1)">查看项目完整性评估</el-button>
						<!-- <el-button type="primary" v-show="!completenesLoading && completenessData!=''" @click="initEvaluation(2)">查看评估结果</el-button> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目简介" prop="summary" label-width="120px">
						<el-input type="textarea" v-model="project.summary" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目落地诉求" label-width="120px">
						<el-input type="textarea" v-model="project.demand" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目政策诉求" label-width="120px">
						<el-input type="textarea" v-model="project.policy" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div v-if="type == 1">
			<el-divider><i class="el-icon-user-solid"></i>联系人</el-divider>
			<h3 class="mb-3 content-title">联系人</h3>
			<el-form ref="contactForm" :model="contact" :rules="contactRules" label-width="120px">
				<el-row>
					<el-col :span="10">
						<el-form-item label="姓名" prop="contactName" label-width="120px">
							<el-input v-model="contact.contactName" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :offset="3" :span="10">
						<el-form-item label="手机号" prop="mobile" label-width="120px">
							<el-input v-model="contact.mobile" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="性别" prop="gender" label-width="120px">
							<el-select v-model="contact.gender">
								<el-option label="男" value="1"></el-option>
								<el-option label="女" value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :offset="3" :span="10">
						<el-form-item label="部门" prop="departmentName" label-width="120px">
							<el-input v-model="contact.departmentName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="职位" prop="position" label-width="120px">
							<el-input v-model="contact.position"></el-input>
						</el-form-item>
					</el-col>
					<el-col :offset="3" :span="10">
						<el-form-item label="微信" prop="weixin" label-width="120px">
							<el-input v-model="contact.weixin"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="QQ" prop="qq" label-width="120px">
							<el-input v-model="contact.qq"></el-input>
						</el-form-item>
					</el-col>
					<el-col :offset="3" :span="10">
						<el-form-item label="邮箱" prop="email" label-width="120px">
							<el-input v-model="contact.email"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark" label-width="120px">
							<el-input type="textarea" v-model="contact.remark" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
			</el-form>
		</div>
		<div class="clear-both" v-show="type == 1">
			<el-button type="primary" class="fr" @click="postCusInfo"
				:loading="loadingAddBtn">{{ loadingAddBtn ? '保存中...' : '保存' }}</el-button>
			<!-- <el-button class="fr mr-1" @click="postCusContact">上传联系人</el-button> -->
			<!-- <el-button class="fr mr-1" @click="isDisabled = false">编辑</el-button> -->
		</div>
		<el-dialog class="localChain white-bg" custom-class="initiate_box_dialog" :title="dialogTitle" center
			:visible.sync="isInitiate" top="">
			<div class="pre-wrap-text" v-html="completenessData"></div>
		</el-dialog>
	</div>
</template>
<script>
import seach from './seach.vue';
export default {
	name: "addProject",
	components: { seach },
	data() {
		return {
			project: {
				name: '',
				summary: '',
				showFileList: true,
				status: '',
				investorName: '',
				district: '',
				industryType: [],
				investmentAmount: '',
				expectedAnnualOutput: '',
				expectedProfit: '',
				expectedEmployment: '',
				demand: '',
				policy: '',
				projectFileList: [],
				fileList: [],
				company: '1',
				customerName: '',
				taxation: '',
			},
			contact: {
				contactId: 0,
				contactName: '',
				mobile: '',
				gender: '',
				departmentName: '',
				position: '',
				weixin: '',
				qq: '',
				email: '',
				remark: '',
			},
			loadingAddBtn: false,
			tempProjectFileList: [], // 项目文件列表
			isDisabled: false,
			projectStatusOptions: [{ value: '1', label: '待处理' }, { value: '2', label: '处理中' }, { value: '3', label: '处理完成' }],
			industryTypeOptions: [{ value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' }],
			userdata: {},
			contactRules: {},
			rules: {
				name: [
					{ required: true, message: '请输入项目名称', trigger: 'blur' },
				],
				status: [
					{ required: true, message: '请选择项目状态', trigger: 'change' },
				],
				industryType: [
					{ type: 'array', required: true, message: '请选择产业类型', trigger: 'change' },
				],
				investorName: [
					{ required: true, message: '请输入投资人名称', trigger: 'blur' },
				],
				investmentAmount: [
					{ required: true, message: '请输入投资总额', trigger: 'blur' },
				],
				expectedAnnualOutput: [
					{ required: true, message: '请输入预计年产值', trigger: 'blur' },
				],
				fileList: [
					{ required: true, message: '请上传项目文件', trigger: 'change' },
					{ type: 'array', min: 1, message: '请至少上传一个文件', trigger: 'change' }
				],
				summary: [
					{ required: true, message: '请输入项目简介', trigger: 'blur' },
				]
			},
			detailData: {},
			isInitiate: false,
			dialogTitle: '项目信息完整性评估',
			completenessData: '',
			completenesLoading: false,
			pageType: 1, //1新增2详情页编辑
		};
	},
	watch: {
		type: {
			handler(newValue, oldValue) {
				if (this.type == 2) {
					this.isDisabled = true;
				} else {
					this.isDisabled = false;
				}
			}
		},
		projectData: {
			handler(newValue, oldValue) {
				console.log('项目数据:', newValue);
				this.pageData();
			},
			immediate: true,
			deep: true
		}
	},
	props: {
		type: { default: 1, type: Number },//1新增2详情页编辑
		projectData: { default() { }, type: Object },
		cusid: { default: 0, type: [String, Number] },
		isEdit: { default: false, type: Boolean },
	},
	created() {
		this.userdata = this.getuseriformation();
	},
	mounted() {
		this.pageType = this.type;
		this.getProjectClass();
		this.getStausType();
		if (this.type == 2) { this.isDisabled = true; }
	},
	methods: {
		//评估项目完整性
		initEvaluation(type) {
			if (type == 1) {
				this.completeness();
			} else {
				this.isInitiate = true;
			}
		},
		completeness() {
			let that = this;
			let ajaxurl = this.$api.xmcrm.assessment.Completeness();
			that.completenesLoading = true;
			this.$axios.get(ajaxurl + "?customerId=" + this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				if (res.data.success) {
					that.completenessData = res.data.data;
					console.log('评估结果', res.data.data);
					that.completenesLoading = false;
					that.isInitiate = true;
				} else {
					that.completenesLoading = false;
					that.$message.error(res.data.msg);
				}
			}).catch(function (error) {
				console.log(error);
				that.completenesLoading = false;
				that.$message.error(res.data.msg);
			});
		},
		pageData() {
			if (this.type == 2 && this.projectData) {
				const src = this.projectData || {};
				// 兼容父组件或后端不同字段命名
				this.project.name = src.name || src.project || '';
				this.project.summary = src.summary || src.remark || '';
				this.project.fileName = src.file || src.fileName || '';
				this.project.projectFileList = src.fileList || src.projectFileList || [];
				this.project.fileList = src.fileList || src.projectFileList || [];

				this.project.status = src.status || "";
				// industryType 可能以 bigClass/smallClass 或数组形式提供
				const big = src.bigClass !== undefined ? src.bigClass : (Array.isArray(src.industryType) ? src.industryType[0] : undefined);
				const small = src.smallClass !== undefined ? src.smallClass : (Array.isArray(src.industryType) ? src.industryType[1] : undefined);
				this.project.industryType = [big || '', small || ''];
				this.project.investmentAmount = src.amount || src.investmentAmount || "";
				this.project.expectedAnnualOutput = src.outputValue || src.expectedAnnualOutput || "";
				this.project.expectedProfit = src.profit || src.expectedProfit || "";
				this.project.expectedEmployment = src.employment || src.expectedEmployment || "";
				this.project.demand = src.landing || src.demand || '';
				this.project.policy = src.policy || '';
				this.project.investorName = src.investor || src.investorName || '';
				this.project.customerName = src.customerName || '';
				this.project.taxation = src.taxation || '';

				// 规范文件列表 item.name 字段
				if (this.project.projectFileList && this.project.projectFileList.length > 0) {
					this.project.projectFileList.forEach(item => {
						item.name = item.title || item.name;
					});
				}
			}
		},
		handleSelect(company) {
			console.log('选中项数据1111:', company);
			this.project.customerName = company;
		},
		// 获取项目产业类型
		getProjectClass() {
			let _this = this;
			let ajaxurl = this.$api.tag.notion.list() + '?level=3';
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('三大产业概念数据', res);
				if (res.data.success) {
					let datalist = res.data.list;
					datalist = datalist.filter((list => {
						return list.label.indexOf('未来') < 0;
					}))
					datalist = _this.setIsIntegration(datalist);
					_this.industryTypeOptions = datalist;
				}
			})
		},
		setIsIntegration(notionArray) {
			console.log('整合产业', notionArray);
			let tempData = { label: '传统产业', value: 'DEF', parentList: ['DEF'], children: [] };
			let newTree = [];
			notionArray.forEach((item, i) => {
				// console.log('item', item.label);
				if (item.label == '第一产业' || item.label == '第二产业' || item.label == '第三产业') {
					tempData.children.push(item);
					newTree[0] = tempData;
				}
				if (item.label == '先进制造业') {
					item.label = '战略性新兴产业';
					newTree[1] = item;
				}
				if (item.label == '未来产业') {
					newTree[2] = item;
				}
			});
			// notionArray[0] = newTree;
			console.log('整合产业111', newTree);
			return newTree;
		},
		//获取项目状态类型
		getStausType() {
			let _this = this;
			let ajaxurl = this.$api.xmcrm.parameter.projectStatus();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					let datalist = res.data.list;
					_this.projectStatusOptions = datalist;
				}
			})
		},
		handleRemove(file, fileList) {
			console.log('删除成功31232131231233');
			// console.log(file, fileList);
			this.deleteFile(file.fileId).then((res) => {
				if (res) {
					this.project.projectFileList = fileList; // 更新文件列表 
				}

			})

			console.log(file, fileList);
		},
		handlePreview(file) {
			window.open(file.url);
		},
		handleAvatarSuccess(res, file, fileList) {
			this.project.fileList = fileList;
			console.log('上传成功返回的数据:', fileList);
			// this.project.projectFileList = fileList; // 更新文件列表
			// if (this.project.projectFileList.length != 0 && this.type == 2) {
			// 	this.uploadFileList(file.raw);
			// } 
		},

		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file, fileList) {

			// this.projectFileList = fileList; // 删除文件列表
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		handleOpenURL(url) {
			// 打开新窗口
			window.open(url, '_blank');
		},
		//删除项目附件
		deleteFile(id) {

			return new Promise((resolve, reject) => {
				console.log('删除文件id:', id);
				if (this.type == 1) {
					reject(false);
					return;
				}
				// $.ajax({
				// 	type: "post",
				// 	url: this.$api.xmcrm.customer.deleteFile(),
				// 	headers: {
				// 		AuthToken: this.userdata.token
				// 	},
				// 	data: { fileId: id  },
				// 	success: function (res) {
				// 		if (res.success) {
				// 			this.$message.success('删除成功！');
				// 		resolve(true);
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 		reject(false);
				// 	}
				// 	}
				// })
				let newFormData = new FormData();
				newFormData.append('fileId', id);
				this.$axios.post(this.$api.crxmcrmm.customer.deleteFile(), newFormData, {
					headers: {
						'AuthToken': this.userdata.token, // 自定义请求头，传递 Token
						// 'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then((res) => {
					console.log(res);
					if (res.data.success) {
						this.$message.success('删除成功！');
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
						reject(false);
					}

				})
			});


		},
		// 修改后的上传方法 - 添加进度条支持
		async uploadFileList(file) {
			if (this.pageType == 1) {
				return;
			}
			try {
				let addFileUrl = this.$api.xmcrm.customer.addFile();
				let formData = new FormData();
				formData.append('file', file.file);
				formData.append('customerId', this.detailData.id ? this.detailData.id : this.cusid);

				const response = await this.$axios.post(addFileUrl, formData, {
					headers: {
						'AuthToken': this.userdata.token,
						'Content-Type': 'multipart/form-data'
					},
					// 关键：添加上传进度监听
					onUploadProgress: (progressEvent) => {
						if (progressEvent.lengthComputable) {
							const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
							//   console.log('上传进度:', percent + '%');

							// 手动调用进度回调 - 这是显示进度条的关键！
							file.onProgress({
								percent: percent
							});
						}
					}
				});

				console.log(response);
				if (response.data.success) {
					this.project.fileList = response.data.list;
					// 上传成功回调
					file.onSuccess(response.data);

					//   this.$message.success('上传成功！');
				} else {
					//   file.onError(new Error(response.data.msg || '上传失败'));
					this.$message.error(response.data.msg || '上传失败');
				}

			} catch (error) {
				console.log('上传错误:', error);
			}
		},
		//上传项目信息
		postCusInfo() {
			console.log('上传的项目信息', this.project);
			this.$refs['projectForm'].validate((valid) => {
				if (valid) {
					if (this.isDisabled) {
						this.$message.warning('请勿重复提交');
						return;
					}
					if (this.type == 1) {
						this.pageType = 3;
					}

					this.loadingAddBtn = true;
					// 创建 FormData 对象
					let formData = new FormData();
					formData.append('customerId', this.cusid == '' ? 0 : this.cusid); // 客户 ID
					formData.append('project', this.project.name); // 项目名
					formData.append('summary', this.project.summary); // 项目简介
					// formData.append('file', this.project.projectFileList.length > 0 ? this.project.projectFileList.map(file => file.raw) : ''); // 项目附件
					//bigClass要从projectStatus[0]获取,smallClass要从projectStatus[1]获取,怎么在projectStatus么有值的时候不报错
					formData.append('smallClass', this.project.industryType[1]);
					formData.append('bigClass', this.project.industryType[0]);
					formData.append('status', this.project.status);
					formData.append('amount', this.project.investmentAmount);
					formData.append('outputValue', this.project.expectedAnnualOutput);
					formData.append('profit', this.project.expectedProfit);
					formData.append('employment', this.project.expectedEmployment);
					formData.append('landing', this.project.demand);
					formData.append('policy', this.project.policy);
					formData.append('investor', this.project.investorName);
					formData.append('customerName', this.project.customerName);
					formData.append('taxation', this.project.taxation);

					// 打印 FormData 内容（调试用）
					for (let [key, value] of formData.entries()) {
						console.log(`${key}:`, value);
					}


					this.$emit('postCusInfo', formData);
					// return;
					// 使用 axios 发送 POST 请求
					this.$axios.post(this.$api.xmcrm.project.Post(), formData, {
						headers: {
							// 'Content-Type': 'application/x-www-form-urlencoded',
							'AuthToken': this.userdata.token // 自定义请求头，传递 Token
							// 注意：不要手动设置 Content-Type，让浏览器自动处理
						}
					})
						.then((res) => {
							console.log(res);
							if (res.data.success) { // 假设后台返回的数据在 res.data 中
								this.$message({
									type: 'success',
									message: '项目添加成功!',
								});
								this.detailData = res.data.data;
								//在项目创建完成生成id后上传附件
								if (this.pageType == 3) {
									console.log('准备上传附件:', this.project.fileList);
									for (let i = 0; i < this.project.fileList.length; i++) {
										console.log('准备上传附件2132132132:', this.project.fileList[i]);
										this.uploadFileList({ file: this.project.fileList[i].raw });
									}
									if (this.contact.contactName != '') {
										this.postCusContact();

									}
								}
								this.loadingAddBtn = false;

							} else {
								this.$message.error('添加失败：' + res.data.msg);
							}
							this.loadingAddBtn = false;
						})
						.catch((err) => {
							this.loadingAddBtn = false;
							console.error('上传失败:', err);
							this.$message.error('上传失败，请稍后重试');
						});

				} else {
					console.log('error submit!!');
					this.$message.error('请填写完整的项目信息');
					return false;
				}
			});
			return;

		},
		//上传联系人信息(要等到项目创建完成后再上传)
		postCusContact() {
			console.log('上传的联系人信息', this.contact);
			// 验证手机号（如果有值）
			if (this.contact.mobile && this.contact.mobile.trim()) {
				if (!/^1[3-9]\d{9}$/.test(this.contact.mobile)) {
					this.$message.error('手机号格式不正确')
					return;
				}
			}
			// 验证邮箱（如果有值）
			if (this.contact.email && this.contact.email.trim()) {
				if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.contact.email)) {
					this.$message.error('邮箱格式不正确')
					return;
				}
			}
			this.contact.customerId = this.detailData.id;
			// this.contact.customerId = '159';
			//处理一下filterData里面为‘’和0的数据
			for (let key in this.contact) {
				if (this.contact[key] == '') {
					delete this.contact[key];
				}
			}
			const postData = this.contact;
			console.log('上传的参数', postData);
			// return
			$.ajax({
				type: "POST",
				url: this.$api.xmcrm.contact.post(),
				data: postData,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.$message({
							type: 'success',
							message: '联系人保存成功!',

						})
					} else {

					}
				}
			})
		},
		//重置表单，以防多次提交
		restform() {
			this.$refs['projectForm'].resetFields();
			this.$refs['contactForm'].resetFields();
			this.project = {
				name: '',
				summary: '',
				showFileList: true,
				status: '',
				investorName: '',
				district: '',
				industryType: [],
				investmentAmount: '',
				expectedAnnualOutput: '',
				expectedProfit: '',
				expectedEmployment: '',
				demand: '',
				policy: '',
				projectFileList: [],
				fileList: [],
				company: '1',
				customerName: '',
				taxation: '',
			};
			this.contact = {
				contactId: 0,
				contactName: '',
				mobile: '',
				gender: '',
				email: '',
				customerId: '',
			};
			this.cusid = '';
			this.project.fileList = [];
		},
	}

};

</script>
<style scoped lang="scss">
.content-title {
	color: #5E83CC;

	&::before {
		content: '';
		display: inline-block;
		vertical-align: middle;
		width: 4px;
		height: 16px;
		background-color: #5E83CC;
		margin-right: 8px;
	}
}

::v-deep {

	input[disabled],
	textarea[disabled] {
		background-color: #ffffff !important;
		border-color: #ffffff !important;
		color: #333 !important;
		cursor: auto !important;
	}

}

/* 确保进度条可见 */
:deep(.el-upload-list__item) {
	transition: all 0.3s;
}

:deep(.el-upload-list__item .el-progress) {
	width: 100%;
	margin-top: 5px;
}

:deep(.el-upload-list__item .el-progress-bar) {
	padding-right: 50px;
}

:deep(.el-upload-list__item .el-progress__text) {
	font-size: 12px;
}
</style>